import { LoaderFunction, useLoaderData } from "react-router-dom";
import { getCourseDetails } from "common/api/decimal/methods/course.ts";
import { CourseMaterial } from "../index/coursesLoader.ts";
import {
  CompareCart,
  CompareSettings,
  GroupedOffers,
  getCart,
  getCompareSettings,
  getOffers,
} from "common/api/decimal/methods/compareAndPurchase.ts";
import { once } from "common/utils/function.ts";

export interface PurchaseOptionsData {
  courseMaterial: CourseMaterial;
  groupedOffers: GroupedOffers;
  settings: CompareSettings;
  cart: CompareCart;
}

const loadSettingsOnce = once(() =>
  getCompareSettings().then((data) => data?.data?.compareSettings)
);

export function usePurchaseOptionsLoaderData(): PurchaseOptionsData {
  return useLoaderData() as PurchaseOptionsData;
}

export const loadPurchaseOptions: LoaderFunction = ({
  params: { termId, courseId, isbn },
}) => {
  if (!courseId) {
    return Promise.reject("Failed to find course id");
  } else if (!isbn) {
    return Promise.reject("Failed to find isbn");
  }

  return Promise.all([
    loadSettingsOnce(),
    getCourseDetails(courseId, termId),
    getOffers({ isbn, courseId }),
    getCart(),
  ]).then(([settings, courseData, offersData, cart]) => {
    const material = courseData.data?.books?.find((book) => book.vbid === isbn);
    return {
      courseMaterial: { ...material, courseId },
      groupedOffers: offersData.data,
      settings,
      cart: cart.data,
    };
  });
};
